import { memo } from "react";
import { Col, FormGroup } from "react-bootstrap";
import { UseFormReturn } from "react-hook-form";
import { TranslationComponent } from "../../shared/widgets/TranslationComponent";
import { usePropertyLocales } from "../../../components/property-locale-provider";
import { InsuranceEntity } from "../entity";

export const TranslateComponent = memo((props: UseFormReturn<InsuranceEntity>) => {
  const allowedLocales = usePropertyLocales();

  return (
    <FormGroup as={Col}>
      <Col sm={12}>
        <TranslationComponent
          allowedLocales={allowedLocales}
          {...props.register("translationsList")}
        />
      </Col>
    </FormGroup>
  );
});
